<template>
  <div id="mainContainer">
    <router-view />
  </div>
</template>
<script>
export default {
  // mounted () {
  //   var browerWidth = window.innerWidth //浏览器可视宽度
  //   var baseWidth = 1920 //设计稿宽度
  //   var zoomValue = browerWidth / baseWidth //缩放比例计算
  //   document.getElementById('mainContainer').style.transform =
  //     'scale(' + zoomValue + ',' + zoomValue + ')' //mainContainer为主容器id
  //   window.onresize = function () {
  //     //窗口尺寸变化时，重新计算和缩放
  //     browerWidth = window.innerWidth
  //     zoomValue = browerWidth / baseWidth
  //     document.getElementById('mainContainer').style.transform =
  //       'scale(' + zoomValue + ',' + zoomValue + ')'
  //   }
  // }
}
</script>

<style lang="less">
body,
html {
  height: 100%;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
#app {
  height: 100%;
  // padding: 0 350px;
}
</style>
